export const projectItemMixin = {
  methods: {
    isItemSet (item) {
      return item.current_participants >= item.min_participants
    },
    isItemFull (item) {
      return item.current_participants === item.max_participants
    },
    isItemStillJoinable (item) {
      return this.isItemSet(item) && !this.isItemFull(item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/project-item.js